import React from "react";
import { Popup } from "../mobile-popup/popup";
import { getActionIcon, getIconsList } from "../utils";
import { breakpoint } from "../../../../../utils/breakpoint";
import PropTypes from "prop-types";

import "./social-share.m.css";

export class Vertical extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  toggleShare = () => {
    this.setState(prevState => ({
      open: !prevState.open
    }));
  };

  closePopup = () =>
    this.setState({
      open: false
    });

  render() {
    const { fbUrl, twitterUrl, linkedinUrl, whatsappUrl, grey, primaryColor = "#333" } = this.props;
    const greyShade = "#333";
    const greyColor = grey ? "grey-color-icons" : "";
    return (
      <div>
        <ul
          className={`social-share-icons ${greyColor}`}
          styleName={`vertical ${this.state.open ? "open" : ""} ${breakpoint("tablet") ? "floating-share" : ""}`}
        >
          <li className="social-share-icon" styleName="share" key="vertical-0">
            <span onClick={this.toggleShare}>{getActionIcon(this.state.open, grey, greyShade, primaryColor)}</span>
          </li>
          {getIconsList({ fbUrl, twitterUrl, linkedinUrl, whatsappUrl, color: grey ? "#333" : "" })}
        </ul>
        {breakpoint("tablet") && this.state.open && <Popup closePopup={this.closePopup} {...this.props} />}
      </div>
    );
  }
}

Vertical.propTypes = {
  fbUrl: PropTypes.string,
  twitterUrl: PropTypes.string,
  linkedinUrl: PropTypes.string,
  whatsappUrl: PropTypes.string,
  grey: PropTypes.bool,
  primaryColor: PropTypes.string
};
